import { memo } from 'react';

import { Form } from '@components/form';
import { useLocale } from '@locale/translate';

import { useTranslatedFieldText } from './locale';
import { DateField } from './types';

export const DateInput = memo<{ field: DateField }>(({ field }) => {
  const currentLanguage = useLocale();

  return (
    <Form.DatePicker
      {...field}
      lang={currentLanguage === 'is' ? 'is' : 'en'}
      label={useTranslatedFieldText(field.text)}
      defaultValue={field.value}
    />
  );
});
